import { render } from "./Successful.vue?vue&type=template&id=4b987286&scoped=true"
import script from "./Successful.vue?vue&type=script&lang=js"
export * from "./Successful.vue?vue&type=script&lang=js"

import "./Successful.vue?vue&type=style&index=0&id=4b987286&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b987286"]])

export default __exports__